import styled from "styled-components";
import { Row } from "react-bootstrap";
import { PRIMARY_COLORS } from "../../../../../consts/colors";

export const MeasureRow = styled(Row)`
   margin-right: 0px;
   margin-left: 0px;
   padding-left: 0px;
   padding-right: 0px;
   .label-section-css {
      display: flex;
      align-items: center;
      gap: 25px;
      padding: 15px 20px;
      border-bottom: 1px solid ${PRIMARY_COLORS.PLATINUM};
      .graph-img-css {
         width: 20px;
         height: 18px;
      }
      .label-span-css {
         font-size: 12px !important;
         font-weight: bold;
      }
   }
   .value-section-css {
      padding-left: 0px;
      padding-right: 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid ${PRIMARY_COLORS.PLATINUM};
      background-color: ${PRIMARY_COLORS.LILY_WHITE};
      font-size: 12px;
      font-weight: bold;
   }
`;
